export enum Events {
    // eslint-disable-next-line no-unused-vars
    reload = 'eventgallery-minicart-reload',
    // eslint-disable-next-line no-unused-vars
    prepareAdd2cartDialogContent = 'eventgallery-prepare-add2cartdialogcontent',
    // eslint-disable-next-line no-unused-vars
    rebindAdd2CartButtons = 'eventgallery-rebind-add2cart-buttons'
}